<span class="created-by">Copyright DEALER <b>CURATOR</b>&emsp;©&emsp;
  {{date}}
</span>
